import type { PaymentMethodIconType } from '@aibees/shared/definition';

const BASE_PATH = '/assets/images/payment-methods';

interface PaymentMethodLogoConfig {
  src: string;
  label: string;
}

const FALLBACK: PaymentMethodLogoConfig = {
  src: `${BASE_PATH}/mastercard.svg`,
  label: 'Card',
};

export const PAYMENT_METHOD_LOGO_CONFIG: Record<
  PaymentMethodIconType,
  PaymentMethodLogoConfig
> = {
  VISA: { src: `${BASE_PATH}/visa.svg`, label: 'Visa Card' },
  MASTERCARD: { src: `${BASE_PATH}/mastercard.svg`, label: 'Master Card' },
  AMERICAN_EXPRESS: {
    src: `${BASE_PATH}/american-express.svg`,
    label: 'AMEX Card',
  },
  DISCOVER: { src: `${BASE_PATH}/discover.svg`, label: 'Discover Card' },
  JCB: { src: `${BASE_PATH}/jcb.svg`, label: 'JCB Card' },
  DINERS_CLUB: {
    src: `${BASE_PATH}/diners-club.svg`,
    label: 'Diners Club Card',
  },
  UNIONPAY: { src: `${BASE_PATH}/unionpay.svg`, label: 'CUP Card' },
  APPLE_PAY: { src: `${BASE_PATH}/apple-pay.svg`, label: 'Apple Pay' },
  GOOGLE_PAY: { src: `${BASE_PATH}/google-pay.svg`, label: 'Google Pay' },
  SAMSUNG_PAY: { src: `${BASE_PATH}/samsung-pay.svg`, label: 'Samsung Pay' },
  LINK: { src: `${BASE_PATH}/link.svg`, label: 'Link' },
  PAYPAL: { src: `${BASE_PATH}/paypal.svg`, label: 'PayPal' },
  CASHAPP: { src: FALLBACK.src, label: 'Cash App' },
  KLARNA: { src: `${BASE_PATH}/klarna.svg`, label: 'Klarna' },
  SEPA_DEBIT: { src: `${BASE_PATH}/sepa-debit.svg`, label: 'SEPA Debit' },
  IDEAL: { src: `${BASE_PATH}/ideal.svg`, label: 'iDEAL' },
  SOFORT: { src: `${BASE_PATH}/sofort.svg`, label: 'Sofort' },
  US_BANK_ACCOUNT: {
    src: `${BASE_PATH}/us-bank-account.svg`,
    label: 'US Bank Account',
  },
  AU_BECS_DEBIT: {
    src: `${BASE_PATH}/au-becs-debit.svg`,
    label: 'AU BECS Debit',
  },
  BOLETO: { src: `${BASE_PATH}/boleto.svg`, label: 'Boleto' },
  EPS: { src: `${BASE_PATH}/eps.svg`, label: 'EPS' },
  FPX: { src: `${BASE_PATH}/fpx.svg`, label: 'FPX' },
  P24: { src: `${BASE_PATH}/p24.svg`, label: 'P24' },
  BANCONTACT: { src: FALLBACK.src, label: 'Bancontact' },
  ALIPAY: { src: `${BASE_PATH}/alipay.svg`, label: 'Alipay' },
  WECHAT_PAY: { src: FALLBACK.src, label: 'WeChat Pay' },
  CARD: { src: FALLBACK.src, label: 'Card' },
  BANK_TRANSFER: {
    src: `${BASE_PATH}/bank-transfer.svg`,
    label: 'Bank Transfer',
  },
  UNKNOWN: FALLBACK,
};

export const getPaymentMethodLogoConfig = (
  iconType?: PaymentMethodIconType
): PaymentMethodLogoConfig =>
  (iconType && PAYMENT_METHOD_LOGO_CONFIG[iconType]) || FALLBACK;
